import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';

import { ToastService } from '@mode/shared/util-toast';

type AuthState = 'connect_success' | 'connect_error' | 'disconnect_success' | 'disconnect_error' | '';

@Component({
  selector: 'mode-auth-toast',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthToastComponent implements OnInit {
  @Input({ required: true }) state: AuthState = '';

  constructor(private _toastService: ToastService) {}

  ngOnInit(): void {
    if (this.state) {
      switch (this.state) {
        case 'connect_success': {
          this._toastService.success('Google Account connected');
          break;
        }
        case 'connect_error': {
          this._toastService.error('Failed to connect Google Account');
          break;
        }
        case 'disconnect_success': {
          this._toastService.success('Google Account disconnected');
          break;
        }
        case 'disconnect_error': {
          this._toastService.error('Failed to disconnect Google Account');
          break;
        }
      }
    }
  }
}
